import React, { Component } from 'react';
import { Waypoint } from "react-waypoint";

import tinycolor from 'tinycolor2';
import * as d3 from 'd3';

import VillagerAvatar from '../components/VillagerAvatar';
import Button from '../components/Button';
import Dialogue from '../components/Dialogue';

import ChartSpecs from '../data/chart_specs';

const colorWheelObjBrightness = ChartSpecs.chartspecs.colorWheelObjBrightness;
const brightnessColorArray = Object.keys(colorWheelObjBrightness);
const brightnessColorRange = Object.values(colorWheelObjBrightness);
var margin = ChartSpecs.chartspecs.margin;


class VillagerAppearanceSkinbrightness extends Component {
  constructor(props){
      super(props);
      this.svgRef = React.createRef();

      this.allVillagers = this.props.villagers;
      this.tierNodes = {};
      // is SkinColor Warm or Cold
      this.allVillagers.forEach((villager) => {
        let skinColor = tinycolor(this.props.villagerSkinColors.get(villager.id))
        villager.skinColorHsl = skinColor.toHsl();
        //Skin color brightness
        if (villager.skinColorHsl.l > 0.67){
          villager.skinColorBrightness = "Light"
        }else if(villager.skinColorHsl.l <= 0.67 && villager.skinColorHsl.h >= 0.33){
          villager.skinColorBrightness = "Medium"
        }else if(villager.skinColorHsl.h < 0.33){
          villager.skinColorBrightness = "Dark"
        }
      });
   }

   componentDidMount() {
     this.svg = d3.select(this.svgRef.current);
     this.drawBrightnessChart()
   }

    drawBrightnessChart(){
      var svg = this.svg,
          chartWidth = this.svgRef.current.clientWidth,
          chartHeight = 430,
          stackKeys = brightnessColorArray,
          tooltip = d3.select('#tooltip-skinbrightness'),
          radius = 40,
          skinColors =  this.props.villagerSkinColors,
          textColors =  this.props.villagerTextColors;


      let allVillagers = this.allVillagers;

     /* COLOR NODES SORT */
     //let tierNodes = d3.group(allVillagers, d => d.tier);
     let tierNodes = d3.groups(allVillagers, d => d.tier, d => d.skinColorBrightness);
     let tierNodes2 = d3.rollup(allVillagers, v => v.length, d => d.tier, d => d.skinColorBrightness);
     let tierArray = [...tierNodes2.keys()];

      let tableData = Array.from(tierNodes2.entries())
      .map(g => {
        const obj = {};
        obj["tier"] = g[0];
        for (let col of stackKeys) {
          const vals = g[1].get(col);
          //console.log("vals: "+vals);
          obj[col] = !vals ? 0 : vals;
        }
        return obj;
      })
     .sort((a, b) => a["tier"] - b["tier"]);

      //return chart.node();
      chartHeight = tierNodes.length * radius + margin.top + margin.bottom

      const yScale = d3.scaleBand()
            //.domain(tierNodes.map(d => d[0])) //tiers
            .domain(tierArray)
            .range([margin.top, chartHeight - margin.bottom])
            .padding(0.25)

      const xScale= d3.scaleLinear()
                    .range([margin.left, chartWidth - margin.right])


    const colorScale = d3.scaleOrdinal()
                .domain(brightnessColorArray)
                .range(brightnessColorRange)
                .unknown("#CCE5E3")

      const xAxis = g => g
                  .attr("transform", `translate(0,${margin.top + 10})`)
                  .call(d3.axisTop(xScale).ticks(chartWidth / 100, "%"))
                  .call(g => g.selectAll(".domain").remove());

      const yAxis = g => g
                .attr("transform", `translate(${margin.left},0)`)
                .call(d3.axisLeft(yScale).tickFormat(function(d,i){ return `T.${d}` }).tickSizeOuter(0))
                .call(g => g.selectAll(".domain").remove())

      const formatPercent = d3.format(".1%");
      const formatValue = x => isNaN(x) ? "N/A" : x.toLocaleString("en")
      /* set up mutiple colli  */
      let basePerRow = 10,
          baseRowWidth = (chartWidth + 0) / (basePerRow + 1);

      const series = d3.stack()
                    .keys(stackKeys)
                    .offset(d3.stackOffsetExpand)
                  (tableData)
                    .map(d => (d.forEach(v => v.key = d.key), d))


      svg.attr("height", chartHeight);
      svg.attr("id", 'skincolorchart');

      svg.append("g")
      .attr("class", 'xaxis')
      .call(xAxis);

      svg.append("g")
      .attr("class", 'yaxis tier-axis no-tick')
      .call(yAxis);

      svg.append("g")
        .selectAll("g")
        .data(series)
        .join("g")
        .attr("fill", d => colorScale(d.key))
        .selectAll("rect")
        .data(d => d)
        .join("rect")
          .attr("x", d => xScale(d[0]))
          .attr("y", (d, i) => yScale(d.data.tier))
          .attr("width", d => xScale(d[1]) - xScale(d[0]))
          .attr("height", yScale.bandwidth())
          .on("mouseenter", function(e,d) {
             const x = xScale(d[0]) + (xScale(d[1]) - xScale(d[0])) / 2;
             const y = yScale(d.data.tier);

             let thisBar = d3.select(this);


             d3.select('#tooltip-skinbrightness')
                         .transition()
                         .duration(200)
                         .style("display", "block");

             d3.select('#tooltip-skinbrightness')
               .html(
                 `<p> <b>${formatValue(d.data[d.key])}</b> ${d.key} skin color villagers</p>`
               ).style(
                     "transform",
                     `translate(` + `calc( -50% + ${x}px),` + `calc(-100% + ${y}px)` + `)`
                   );

              d3.select(this).transition()
                     .duration(350)
                     .style("stroke", d => colorScale(d.key))

           })
           .on('mouseleave', function() {
             d3.select('#tooltip-skinbrightness')
               .transition()
               .duration(200)
               .style("display", "none")

             d3.select(this)
               .transition()
               .style("stroke", 'none')
           })

    }

  render() {
    let allVillagersGroupedByColorTemp = d3.group(this.allVillagers, d => d.skinColorTemp);
    let topVillagers = this.allVillagers.filter(v => v.Average_Popularity_Ranking <= 40);
    let topVillagersGroupedByColorTemp = d3.group(topVillagers, d => d.skinColorTemp);


    let chartKeyList = brightnessColorArray.map(list => {
        return (
          <li key={list}><span style={{backgroundColor: colorWheelObjBrightness[list]}}></span>{list}</li>
        )
    })

    return (
      <div ref={this.props.innerRef}  id={`villager-${this.props.step}`} className="step category-appearance">
        <h2 className="title">Skin brightness</h2>
        <p className="paragraph">In addition to the color hue, we also examined the brightness of each villager’s skin color to see if there might be any interesting correlations with popularity. Working with the Hex color codes once again, we categorized them into Dark, Medium, and Light shades.</p>

        <ul className={`chart-key-list short-list`}>
          {chartKeyList}
        </ul>
        <div className="svg-wrapper">
          <div id="tooltip-skinbrightness" className="bar-tooltip"></div>
          <svg ref={this.svgRef} width="100%"></svg>
        </div>
        <p className="paragraph"> Most of the villagers have a light-to-medium color brightness. Again, there are no strong trends, but there do seem to be slightly more light and dark colors in the top few popularity tiers.</p>
        <Dialogue title="Summary" type="regular">
          <p className="paragraph">Overall, there doesn’t seem to be a strong relationship between skin color brightness and villager popularity. </p>
        </Dialogue>
      </div>
    )
  }
}

export default VillagerAppearanceSkinbrightness;
